import type { FC } from 'react';
import { NavArrowWrapper } from '../../Navigation.styles';

type NavArrowProps = { isDirectory: boolean; isOpened: boolean };

export const NavArrow: FC<NavArrowProps> = ({ isDirectory, isOpened }) => (
  <NavArrowWrapper isDirectory={isDirectory} isOpened={isOpened} />
);
